import { useCallback } from "react";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import classNames from "classnames";
import { ChatRecord } from "../chat-types";
import ChatFileMessageItem from "./chat-file-message-item";
import "./chat-message-item.scss";
import { formatTime } from "../../../utils/date-time-utility";
import { Button } from "@mui/material";
import Text from "../../../components/Text";
import Flex from "../../../components/Flex";

interface ChatMessageItemProps {
  record: ChatRecord;
  currentUserId: number;
  setChatUser: (userId: number) => void;
  resendFile: (retryToken: string, fileUuid: string) => void;
  downloadFile: (id: string) => void;
}
const ChatMessageItem = (props: ChatMessageItemProps) => {
  const { record, currentUserId, setChatUser, resendFile, downloadFile } =
    props;
  const { message, file, sender, timestamp } = record;
  const { avatar } = sender;
  const isCurrentUser = currentUserId === sender.userId;

  const onAvatarClick = useCallback(() => {
    if (!isCurrentUser) {
      setChatUser(sender.userId);
    }
  }, [isCurrentUser, sender, setChatUser]);

  const chatMessage = Array.isArray(message) ? message : [message];

  return (
    <div className={classNames("chat-message-item", { myself: isCurrentUser })}>
      <Button
        className="chat-message-avatar"
        onClick={onAvatarClick}
        size="small"
        style={{ width: "20px" }}
      >
        {avatar ? (
          <img src={avatar} className="chat-message-avatar-img" alt="" />
        ) : (
          <PersonOutlineOutlinedIcon />
        )}
      </Button>
      <div className="chat-message-content">
        <div
          className={classNames("chat-message-info", { myself: isCurrentUser })}
        >
          <p className="chat-message-receiver">
            <Text fontSize={"10px"}>
              {formatTime(new Date(timestamp))}

              {isCurrentUser ? " You " : " " + (sender.name || "")}
            </Text>
          </p>
        </div>
        {file ? (
          <ChatFileMessageItem
            className={classNames({ myself: isCurrentUser })}
            file={file}
            id={record.id}
            resendFile={resendFile}
            downloadFile={downloadFile}
          />
        ) : (
          <Flex
            className={classNames("chat-message-text-list", {
              myself: isCurrentUser,
            })}
          >
            {chatMessage.map((text, index) => (
              <Text className={classNames("chat-message-text")} key={index}>
                {text}
              </Text>
            ))}
          </Flex>
        )}
      </div>
    </div>
  );
};
export default ChatMessageItem;
